module.exports = __webpack_public_path__ + "0ccdcce725c9806df248b68800e42a90.png";